import { Route } from "react-router-dom";
import Protected from "../../auth/Protected";
import { UserRole } from "../../../enums";
import { AdminContactUsPage } from "./index";
import ContactUsEditPage from "./ContactUsEditPage";
 

export default (
  <Route path="contact-us">
    <Route
      index
      element={
        <Protected
          path="/admin/contact-us"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <AdminContactUsPage />
        </Protected>
      }
    />
    
    <Route
      path="edit/:id"
      element={
        <Protected
          path="/admin/contact-us/edit/:id"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <ContactUsEditPage />
        </Protected>
      }
    />  
  </Route>
);
